<template>
    <v-card
        class="imageFileCard"
        outlined
        :width="width"
        :ripple="false"
        :height="height"
        @click.stop.native="clickCard"
        :loading="loading"
        style="position: relative"
        :class="{ selected: isSelected }"
    >
        <v-fab-transition>
            <v-btn
                v-show="isSelected"
                @click="clickClose"
                fab
                dark
                small
                color="red"
                absolute
                style="right: 0; top: -3px"
                @click.stop
            >
                <v-icon dark>mdi-close</v-icon>
            </v-btn>
        </v-fab-transition>
        <v-img ref="fileImg" contain height="100%" v-if="imageSrc" :src="imageSrc"></v-img>
    </v-card>
</template>
<script>
export default {
    props: ['width', 'height', 'customerId', 'file', 'isSelected'],
    data: () => ({
        loading: false,
        imageSrc: '',
    }),
    async mounted() {
        this.loading = true;
        try {
            const res = await this.$axios.get(`/api/v1/customer/${this.customerId}/files/${this.file.file_uuid}`, {
                responseType: 'blob',
            });
            this.imageSrc = window.URL.createObjectURL(new Blob([res.data], {type: this.file.mime_type}));
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        clickCard() {
            this.$emit('select', this.file, this.imageSrc);
        },
        clickClose() {
            this.$emit('close', this.file);
        },
    },
    beforeDestroy() {
        window.URL.revokeObjectURL(this.imageSrc);
    },
};
</script>

<style scoped>
.selected {
    border: 2px solid #263238;
}
</style>
